export const parseCommentContent = (content: string) => {
  const queryMatch = content.match(/## Query: (.*?)\n/);
  const suggestionMatch = content.match(/Admin suggestion: (.*?)\n/);

  return {
    query: queryMatch?.[1] || "",
    comment: suggestionMatch?.[1] || "",
  };
};

export const determineSendStyle = (message_length: number, qt: string) => {
  if (message_length > 1) {
    return "bg-primary shadow-md";
  }

  if (qt === "VEC") {
    return "bg-none";
  } else {
    return "bg-[#D0DADB] shadow-md";
  }
};
